import { type CreateShareSavingsAccountForChildProcess, ProcessStatus } from '@generated-types';
import type { PendingProcessConfigType } from '@translation-utils/translation-type';
import { format } from '@translation-utils/use-translation';

export const getLastActivityContent = (
    process: CreateShareSavingsAccountForChildProcess,
    hasApplicantRole: boolean,
    pendingProcess: PendingProcessConfigType,
): { header: string; description: string; action?: keyof typeof pendingProcess.lastActivity.actions } | undefined => {
    switch (process.processStatus) {
        case ProcessStatus.WAITING_FOR_APPROVER_PARENT_CONSENT:
            return {
                header: pendingProcess.lastActivity.waiting.header,
                description: pendingProcess.lastActivity.waiting.description,
            };
        case ProcessStatus.COMPLETED:
            return {
                header: pendingProcess.lastActivity.completed.header,
                description: pendingProcess.lastActivity.completed.description,
                action: 'smartsparReadMore',
            };
        case ProcessStatus.PENDING_KYC_CONSENT:
            if (hasApplicantRole) {
                return {
                    header: format(pendingProcess.lastActivity.pending.applicantParentHeader, process.child.name),
                    description: pendingProcess.lastActivity.pending.description,
                    action: 'completeKYC',
                };
            } else {
                return {
                    header: format(
                        pendingProcess.lastActivity.pending.approverParentHeader,
                        process.applicantParent.name,
                        process.child.name,
                    ),
                    description: pendingProcess.lastActivity.pending.description,
                };
            }
        case ProcessStatus.PENDING_KYC_ADVISOR_REVIEW:
            return {
                header: format(pendingProcess.lastActivity.advisorReview.header, process.child.name),
                description: pendingProcess.lastActivity.advisorReview.description,
            };
        default:
            return undefined;
    }
};
